import * as types from './types'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_STATUS](state, value) {
    if (value !== undefined && value !== null) {
      state.status = value
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.SET_SCHEMA](state, data) {
    state.schema = data
  },
  [types.SET_QUERY_TEMPLATES](state, data) {
    state.queryTemplates = data
  },
  [types.SET_REQUESTS](state, data) {
    state.totalRequests = 0
    state.requests = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalRequests = data[0].TotalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.requests = data
      }
    }
  },
  [types.SET_CURRENT_TEMPLATE](state, template) {
    state.currentTemplate = template
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js